import React, { useState } from "react";
import "./Stats.css";

export default function Stats({ stats, index = 0 }) {
  const [showAll, setShowAll] = useState(false);

  const headers = [
    "Navn",
    "Etappetid",
    "Etappeplass",
    "Etappediff",
    "Tid",
    "Plass",
    "Endring",
    "Diff",
  ];

  const runnersToDisplay = showAll ? stats : [stats[index]].filter(Boolean);

  return (
    <div className="results-container">
      <div className="results-header-actions">
        <h3>Total Resultater</h3>
        <button className="toggle-btn" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Vis kun valgte" : "Vis alle (10)"}
        </button>
      </div>

      <div className="results-grid">
        <div className="grid-header">
          {headers.map((header, idx) => (
            <span key={`h-${idx}`} className="header-cell">
              {header}
            </span>
          ))}
        </div>

        {runnersToDisplay.map((runner, rIdx) => (
          <div className="grid-row" key={rIdx}>
            {runner.map((stat, sIdx) => (
              <span key={`s-${sIdx}`} className="data-cell">
                {stat}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
